module.exports = ol.geom.Point;